import React, { useEffect, useState, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import '../styles/Herosection.css';

import slide1 from '../assets/slide1.jpg';
import slide2 from '../assets/nk2.jpg';
import slide3 from '../assets/slide5.jpg';
import slide4 from '../assets/Pic-16.jpeg';
import slide5 from '../assets/slide7.jpg';

const images = [slide1, slide2, slide3, slide4, slide5];

const words = [
  'ENGINEERING DESIGN',
  'TESTING & COMMISSIONING',
  'EQUIPMENT RENTAL',
  'TRANSFORMER OIL FILTRATION',
  'MANPOWER'
];

const HeroSection = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const wordRefs = useRef([]);

  const [ref, inView] = useInView({


    triggerOnce: true,
    threshold: 0.2
  });

  useEffect(() => {
    const imageInterval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(imageInterval);
  }, []);

  useEffect(() => {
    wordRefs.current.forEach((ref, index) => {
      if (ref) ref.style.opacity = index === currentWordIndex ? 1 : 0;
    });

    
    const wordInterval = setInterval(() => {
      const cw = wordRefs.current[currentWordIndex];
      const nextIndex = (currentWordIndex + 1) % words.length;
      const nw = wordRefs.current[nextIndex];

      const cwLetters = cw.children;
      const nwLetters = nw.children;

      for (let i = 0; i < cwLetters.length; i++) {
        cwLetters[i].className = 'letter out';
      }

      for (let i = 0; i < nwLetters.length; i++) {
        nwLetters[i].className = 'letter behind';
        nw.style.opacity = 1;
        setTimeout(() => {
          nwLetters[i].className = 'letter in';
        }, 340 + i * 80);
      }

      setCurrentWordIndex(nextIndex);
    }, 4000);

    return () => clearInterval(wordInterval);
  }, [currentWordIndex]);

  const splitWord = (word, index) => {
    return (
      <span
        key={index}
        className="word"
        ref={(el) => (wordRefs.current[index] = el)}
        style={{ opacity: index === 0 ? 1 : 0 }}
      >
        {word.split('').map((letter, i) => (
          <span key={i} className="letter in">
            {letter === ' ' ? '\u00A0' : letter}
          </span>
        ))}
      </span>
    );
  };

  return (
    <section
      className="hero-section"
      style={{ backgroundImage: `url(${images[currentIndex]})` }}
    >
      <div
        ref={ref}
        className={`hero-content dark-silver-wrapper ${inView ? 'fade-up' : ''}`}
      >
        <h1 className="dark-silver-text">EXCELLENCE IN IT'S PEAK</h1>

        <div className="text-animation">
          <p className="dynamic-text">
            {words.map((word, i) => splitWord(word, i))}
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
